// import React, { useState } from 'react';
// import PropTypes from 'prop-types';
// import { makeStyles } from '@fluentui/react-components';

// const useStyles = makeStyles({
//   bubbleContainer: {
//     border: '1px solid #4ade80',
//     backgroundColor: '#f4fbf4', 
//     borderRadius: '12px',
//     padding: '16px',
//     width: '100%',
//     maxWidth: '650px',
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '12px',
//     fontFamily: 'Arial, sans-serif',
//     boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
//     position: 'relative'
//   },
//   foundHeader: {
//     fontSize: '12px',
//     fontWeight: 'bold',
//     color: '#333',
//     marginBottom: '8px'
//   },
//   doiItem: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '8px',
//     borderBottom: '1px solid #d1d1d1',
//     paddingBottom: '16px',
//     marginBottom: '4px',
//     ':last-child': {
//       borderBottom: 'none',
//       paddingBottom: '0',
//       marginBottom: '0'
//     }
//   },
//   headerRow: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'flex-start',
//     gap: '10px'
//   },
//   title: {
//     fontSize: '14px',
//     color: '#0056b3',
//     fontWeight: 'bold',
//     margin: 0,
//   },
//   downloadBtn: {
//     minWidth: 'auto',
//     padding: '4px 6px',
//     backgroundColor: '#ffffff',
//     border: '1px solid #ccc',
//     borderRadius: '4px',
//     cursor: 'pointer',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     ':hover': { backgroundColor: '#e0e0e0' }
//   },
//   metaGrid: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '4px',
//     fontSize: '11px',
//     color: '#333'
//   },
//   metaLabel: {
//     fontWeight: 'bold',
//     color: '#005a46',
//     marginRight: '4px'
//   },
//   sectionLabel: {
//     fontSize: '11px',
//     fontWeight: 'bold',
//     color: '#005a46',
//     marginTop: '8px',
//     marginBottom: '2px'
//   },
//   snippet: {
//     fontSize: '11px',
//     color: '#333',
//     lineHeight: '1.5',
//     whiteSpace: 'pre-line', // Ensure \n line-breaks format correctly
//   },
//   footerNote: {
//     fontSize: '10px',
//     color: '#666',
//     marginTop: '4px'
//   },
//   // NEW: Styling for the Show More/Less button
//   toggleBtn: {
//     background: 'none',
//     border: 'none',
//     color: '#0056b3',
//     cursor: 'pointer',
//     fontSize: '11px',
//     fontWeight: 'bold',
//     padding: '4px 0 0 0',
//     marginTop: '4px',
//     display: 'inline-block',
//     ':hover': {
//       textDecoration: 'underline'
//     }
//   }
// });

// // ==========================================
// // NEW: Reusable Truncated Text Component
// // ==========================================
// const TruncatedText = ({ text, maxLength = 500 }) => {
//   const styles = useStyles();
//   const [isExpanded, setIsExpanded] = useState(false);

//   if (!text) return null;

//   // Determine if the text is long enough to require truncation
//   const shouldTruncate = text.length > maxLength;
  
//   // Cut the text off and add ellipsis if it's truncated and not expanded
//   const displayText = (shouldTruncate && !isExpanded) 
//     ? text.substring(0, maxLength) + "..." 
//     : text;

//   return (
//     <div>
//       <div className={styles.snippet} dangerouslySetInnerHTML={{ __html: displayText }} />
//       {shouldTruncate && (
//         <button 
//           className={styles.toggleBtn} 
//           onClick={() => setIsExpanded(!isExpanded)}
//         >
//           {isExpanded ? "Show less" : "Show more"}
//         </button>
//       )}
//     </div>
//   );
// };


// const RomineDoiBubble = ({ doiList, totalCount, children }) => {
//   const styles = useStyles();

//   // Show a "Not Found" box if no results
//   if (!doiList || doiList.length === 0) {
//     return (
//       <div className={styles.bubbleContainer}>
//         <div className={styles.foundHeader}>Found: 0 article(s)</div>
//         <div style={{ fontSize: '12px', color: '#666', padding: '10px 0' }}>
//           No articles, data, or abstracts were found for your query.
//         </div>
//       </div>
//     );
//   }
    
//   return (
//     <div className={styles.bubbleContainer}>
//       {/* Header indicating count */}
//       <div className={styles.foundHeader}>Found : {totalCount || doiList.length} article(s)
//         {totalCount > doiList.length ? ` (Showing ${doiList.length})` : ''}
//       </div>

//       {/* Loop through the array of DOIs */}
//       {doiList.map((doiData, index) => (
//         <div key={doiData.doi || index} className={styles.doiItem}>
          
//           {/* Header: Title and Download Icon */}
//           <div className={styles.headerRow}>
//             <h3 className={styles.title}>{index + 1}. {doiData.title}</h3>
//             <button className={styles.downloadBtn} title="Download">
//               <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
//                 <polyline points="7 10 12 15 17 10"></polyline>
//                 <line x1="12" y1="15" x2="12" y2="3"></line>
//               </svg>
//             </button>
//           </div>

//           {/* Meta Information */}
//           <div className={styles.metaGrid}>
//             <div><span className={styles.metaLabel}>DOI:</span>{doiData.doi}</div>
//             {doiData.journal && <div><span className={styles.metaLabel}>Journal:</span>{doiData.journal}</div>}
//             {doiData.publicationDetails && <div><span className={styles.metaLabel}>Publication Details:</span>{doiData.publicationDetails}</div>}
//             {doiData.publicationDate && <div><span className={styles.metaLabel}>Publication Date:</span>{doiData.publicationDate}</div>}
//             {doiData.authors && <div><span className={styles.metaLabel}>Authors:</span>{doiData.authors}</div>}
//           </div>

//           {/* Abstract Section - Using Truncated Component */}
//           {doiData.abstract && (
//             <div>
//               <div className={styles.sectionLabel}>Abstract</div>
//               <TruncatedText text={doiData.abstract} maxLength={400} />
//             </div>
//           )}

//           {/* Full Text Snippet - Using Truncated Component */}
//           {doiData.fullTextSnippet && (
//             <div>
//               <div className={styles.sectionLabel}>Full Text {doiData.abstract && '(Preview)'}</div>
//               <TruncatedText text={doiData.fullTextSnippet} maxLength={600} />
//               {!doiData.abstract && <div className={styles.footerNote}>(Text truncated for display purposes)</div>}
//             </div>
//           )}
//         </div>
//       ))}

//       {/* Feedback Actions (Thumbs Up/Down) */}
//       {children}
//     </div>
//   );
// };

// RomineDoiBubble.propTypes = {
//   doiList: PropTypes.array.isRequired,
//   children: PropTypes.node
// };

// export default RomineDoiBubble;

// green boarder color UI..

// import React, { useState } from 'react';
// import PropTypes from 'prop-types';
// import { makeStyles } from '@fluentui/react-components';

// const useStyles = makeStyles({
//   bubbleContainer: {
//     border: '1px solid #4ade80',
//     backgroundColor: '#f4fbf4', 
//     borderRadius: '12px',
//     padding: '16px',
//     width: '100%',
//     maxWidth: '650px',
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '12px',
//     fontFamily: 'Arial, sans-serif',
//     boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
//     position: 'relative'
//   },
//   foundHeader: {
//     fontSize: '12px',
//     fontWeight: 'bold',
//     color: '#333',
//     marginBottom: '8px'
//   },
//   doiItem: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '8px',
//     borderBottom: '1px solid #d1d1d1',
//     paddingBottom: '16px',
//     marginBottom: '4px',
//     ':last-child': {
//       borderBottom: 'none',
//       paddingBottom: '0',
//       marginBottom: '0'
//     }
//   },
//   headerRow: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'flex-start',
//     gap: '10px'
//   },
//   title: {
//     fontSize: '14px',
//     color: '#0056b3',
//     fontWeight: 'bold',
//     margin: 0,
//   },
//   downloadBtn: {
//     minWidth: 'auto',
//     padding: '4px 6px',
//     backgroundColor: '#ffffff',
//     border: '1px solid #ccc',
//     borderRadius: '4px',
//     cursor: 'pointer',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     ':hover': { backgroundColor: '#e0e0e0' }
//   },
//   metaGrid: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '4px',
//     fontSize: '11px',
//     color: '#333'
//   },
//   metaLabel: {
//     fontWeight: 'bold',
//     color: '#005a46',
//     marginRight: '4px'
//   },
//   sectionLabel: {
//     fontSize: '11px',
//     fontWeight: 'bold',
//     color: '#005a46',
//     marginTop: '8px',
//     marginBottom: '2px'
//   },
//   snippet: {
//     fontSize: '11px',
//     color: '#333',
//     lineHeight: '1.5',
//     whiteSpace: 'pre-line', // Ensure \n line-breaks format correctly
//   },
//   footerNote: {
//     fontSize: '10px',
//     color: '#666',
//     marginTop: '4px'
//   },
//   toggleBtn: {
//     background: 'none',
//     border: 'none',
//     color: '#0056b3',
//     cursor: 'pointer',
//     fontSize: '11px',
//     fontWeight: 'bold',
//     padding: '4px 0 0 0',
//     marginTop: '4px',
//     display: 'inline-block',
//     ':hover': {
//       textDecoration: 'underline'
//     }
//   }
// });

// // ==========================================
// // INCREMENTAL Truncated Text Component
// // ==========================================
// const TruncatedText = ({ text, initialLength = 400, chunkSize = 400 }) => {
//   const styles = useStyles();
  
//   // Track the CURRENT visible character limit instead of true/false
//   const [visibleLength, setVisibleLength] = useState(initialLength);

//   if (!text) return null;

//   // Check if we have revealed all the text
//   const isFullyVisible = visibleLength >= text.length;
//   // Check if the text was long enough to need truncating in the first place
//   const shouldTruncate = text.length > initialLength;

//   // Slice the text up to the current visible length
//   const displayText = isFullyVisible 
//     ? text 
//     : text.substring(0, visibleLength) + "...";

//   const handleToggle = () => {
//     if (isFullyVisible) {
//       // If it's fully open, reset it back to the original small size
//       setVisibleLength(initialLength);
//     } else {
//       // Add 'chunkSize' more characters to the visible length
//       setVisibleLength(prev => prev + chunkSize);
//     }
//   };

//   return (
//     <div>
//       <div className={styles.snippet} dangerouslySetInnerHTML={{ __html: displayText }} />
//       {shouldTruncate && (
//         <button 
//           className={styles.toggleBtn} 
//           onClick={handleToggle}
//         >
//           {isFullyVisible ? "Show less" : "Show more..."}
//         </button>
//       )}
//     </div>
//   );
// };


// const RomineDoiBubble = ({ doiList, totalCount, children }) => {
//   const styles = useStyles();

//   // Show a "Not Found" box if no results
//   if (!doiList || doiList.length === 0) {
//     return (
//       <div className={styles.bubbleContainer}>
//         <div className={styles.foundHeader}>Found: 0 article(s)</div>
//         <div style={{ fontSize: '12px', color: '#666', padding: '10px 0' }}>
//           No articles, data, or abstracts were found for your query.
//         </div>
//       </div>
//     );
//   }
    
//   return (
//     <div className={styles.bubbleContainer}>
//       {/* Header indicating count */}
//       <div className={styles.foundHeader}>Found : {totalCount || doiList.length} article(s)
//         {totalCount > doiList.length ? ` (Showing ${doiList.length})` : ''}
//       </div>

//       {/* Loop through the array of DOIs */}
//       {doiList.map((doiData, index) => (
//         <div key={doiData.doi || index} className={styles.doiItem}>
          
//           {/* Header: Title and Download Icon */}
//           <div className={styles.headerRow}>
//             <h3 className={styles.title}>{index + 1}. {doiData.title}</h3>
//             <button className={styles.downloadBtn} title="Download">
//               <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
//                 <polyline points="7 10 12 15 17 10"></polyline>
//                 <line x1="12" y1="15" x2="12" y2="3"></line>
//               </svg>
//             </button>
//           </div>

//           {/* Meta Information */}
//           <div className={styles.metaGrid}>
//             <div><span className={styles.metaLabel}>DOI:</span>{doiData.doi}</div>
//             {doiData.journal && <div><span className={styles.metaLabel}>Journal:</span>{doiData.journal}</div>}
//             {doiData.publicationDetails && <div><span className={styles.metaLabel}>Publication Details:</span>{doiData.publicationDetails}</div>}
//             {doiData.publicationDate && <div><span className={styles.metaLabel}>Publication Date:</span>{doiData.publicationDate}</div>}
//             {doiData.authors && <div><span className={styles.metaLabel}>Authors:</span>{doiData.authors}</div>}
//           </div>

//           {/* Abstract Section - Using Incremental Truncated Component */}
//           {doiData.abstract && (
//             <div>
//               <div className={styles.sectionLabel}>Abstract</div>
//               <TruncatedText 
//                 text={doiData.abstract} 
//                 initialLength={400} 
//                 chunkSize={400} 
//               />
//             </div>
//           )}

//           {/* Full Text Snippet - Using Incremental Truncated Component */}
//           {doiData.fullTextSnippet && (
//             <div>
//               <div className={styles.sectionLabel}>Full Text {doiData.abstract && '(Preview)'}</div>
//               <TruncatedText 
//                 text={doiData.fullTextSnippet} 
//                 initialLength={500} 
//                 chunkSize={600} 
//               />
//               {!doiData.abstract && <div className={styles.footerNote}>(Text truncated for display purposes)</div>}
//             </div>
//           )}
//         </div>
//       ))}

//       {/* Feedback Actions (Thumbs Up/Down) */}
//       {children}
//     </div>
//   );
// };

// RomineDoiBubble.propTypes = {
//   doiList: PropTypes.array.isRequired,
//   children: PropTypes.node
// };

// export default RomineDoiBubble;




// DARK BROWN COLOR UI AS SIMILAR TO SEMENTIC SEARCH..


// import React, { useState } from 'react';
// import PropTypes from 'prop-types';
// import { makeStyles, shorthands } from '@fluentui/react-components';

// const useStyles = makeStyles({
//  bubbleContainer: {
//   backgroundColor: '#ffffff',
//   // Solid warm gray border matching the Semantic Search UI
//   ...shorthands.border('1px', 'solid', '#706b69'), 
//   ...shorthands.borderRadius('8px'),
//   boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
//   display: 'flex',
//   flexDirection: 'column',
//   overflow: 'hidden',
//   width: '100%',
//   maxWidth: '650px',
//   position: 'relative'
//  },
//  foundHeader: {
//   display: 'flex',
//   justifyContent: 'space-between',
//   alignItems: 'center',
//   padding: '6px 12px',
//   // Harmonious light gray pagination background
//   backgroundColor: '#f5f4f3', 
//   borderBottom: '1px solid #706b69',
//   fontSize: '11px',
//   fontWeight: '700',
//   color: '#706b69',
//  },
//  doiItem: {
//   display: 'flex',
//   flexDirection: 'column',
//   gap: '8px',
//   borderBottom: '1px solid #edebe9',
//   padding: '16px',
//   ':last-child': {
//    borderBottom: 'none',
//   }
//  },
//  headerRow: {
//   display: 'flex',
//   justifyContent: 'space-between',
//   alignItems: 'flex-start',
//   gap: '10px'
//  },
//  title: {
//   fontSize: '13.5px',
//   color: '#0066cc', // Standard blue hyperlink color
//   fontWeight: '600',
//   margin: 0,
//   lineHeight: '1.4',
//   textDecorationLine: 'none',
//   ':hover': {
//    textDecorationLine: 'underline',
//    color: '#004b93',
//   }
//  },
//  downloadBtn: {
//   minWidth: 'auto',
//   padding: '4px',
//   backgroundColor: 'transparent',
//   border: 'none',
//   borderRadius: '4px',
//   cursor: 'pointer',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   color: '#706b69', // Gray icon outline
//   ':hover': { 
//    backgroundColor: '#edebe9',
//    color: '#333333'
//   }
//  },
//  metaGrid: {
//   display: 'flex',
//   flexDirection: 'column',
//   gap: '6px',
//   fontSize: '11px',
//   color: '#333'
//  },
//  metaLabel: {
//   fontWeight: '700',
//   color: '#706b69', // Warm gray label fonts
//   marginRight: '6px'
//  },
//  sectionLabel: {
//   fontSize: '11.5px',
//   fontWeight: '700',
//   color: '#706b69', // Bold section titles
//   marginTop: '14px',
//   marginBottom: '4px'
//  },
//  snippet: {
//   fontSize: '11.5px',
//   color: '#333',
//   lineHeight: '1.6',
//   whiteSpace: 'pre-line',
//  },
//  footerNote: {
//   fontSize: '10px',
//   color: '#666',
//   marginTop: '4px'
//  },
//  toggleBtn: {
//   background: 'none',
//   border: 'none',
//   color: '#706b69', 
//   cursor: 'pointer',
//   fontSize: '11px',
//   fontWeight: 'bold',
//   padding: '4px 0 0 0',
//   marginTop: '4px',
//   display: 'inline-block',
//   ':hover': {
//    textDecoration: 'underline'
//   }
//  },
//  cardFooter: {
//   padding: '8px 16px',
//   backgroundColor: '#fafafa',
//   borderTop: '1px solid #f0f0f0',
//   display: 'flex',
//   justifyContent: 'flex-end', // Aligns feedback actions correctly to the right
//   alignItems: 'center',
//  }
// });

// // ==========================================
// // INCREMENTAL Truncated Text Component
// // ==========================================
// const TruncatedText = ({ text, initialLength = 400, chunkSize = 400 }) => {
//  const styles = useStyles();
//  const [visibleLength, setVisibleLength] = useState(initialLength);

//  if (!text) return null;

//  const isFullyVisible = visibleLength >= text.length;
//  const shouldTruncate = text.length > initialLength;

//  const displayText = isFullyVisible 
//   ? text 
//   : text.substring(0, visibleLength) + "...";

//  const handleToggle = () => {
//   if (isFullyVisible) {
//    setVisibleLength(initialLength);
//   } else {
//    setVisibleLength(prev => prev + chunkSize);
//   }
//  };

//  return (
//   <div>
//    <div className={styles.snippet} dangerouslySetInnerHTML={{ __html: displayText }} />
//    {shouldTruncate && (
//     <button 
//      className={styles.toggleBtn} 
//      onClick={handleToggle}
//     >
//      {isFullyVisible ? "Show less" : "Show more..."}
//     </button>
//    )}
//   </div>
//  );
// };

// const RomineDoiBubble = ({ doiList, totalCount, children }) => {
//  const styles = useStyles();

//  // Show a "Not Found" box if no results
//  if (!doiList || doiList.length === 0) {
//   return (
//    <div className={styles.bubbleContainer}>
//     <div className={styles.foundHeader}>Found: 0 article(s)</div>
//     <div style={{ fontSize: '11.5px', color: '#666', padding: '16px' }}>
//      No articles, data, or abstracts were found for your query.
//     </div>
//    </div>
//   );
//  }
   
//  return (
//   <div className={styles.bubbleContainer}>
//    {/* Header indicating count with light gray style */}
//    <div className={styles.foundHeader}>
//     <span>
//      Found : {totalCount || doiList.length} article(s)
//      {totalCount > doiList.length ? ` (Showing ${doiList.length})` : ''}
//     </span>
//    </div>

//    {/* Loop through the array of DOIs */}
//    {doiList.map((doiData, index) => (
//     <div key={doiData.doi || index} className={styles.doiItem}>
      
//      {/* Header: Title and Download Icon */}
//      <div className={styles.headerRow}>
//       <h3 className={styles.title}>{index + 1}. {doiData.title}</h3>
//       <button className={styles.downloadBtn} title="Download">
//        {/* Set stroke to currentColor to automatically respond to hover states */}
//        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//         <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
//         <polyline points="7 10 12 15 17 10"></polyline>
//         <line x1="12" y1="15" x2="12" y2="3"></line>
//        </svg>
//       </button>
//      </div>

//      {/* Meta Information List */}
//      <div className={styles.metaGrid}>
//       <div><span className={styles.metaLabel}>DOI:</span>{doiData.doi}</div>
//       {doiData.journal && <div><span className={styles.metaLabel}>Journal:</span>{doiData.journal}</div>}
//       {doiData.publicationDetails && <div><span className={styles.metaLabel}>Publication Details:</span>{doiData.publicationDetails}</div>}
//       {doiData.publicationDate && <div><span className={styles.metaLabel}>Publication Date:</span>{doiData.publicationDate}</div>}
//       {doiData.authors && <div><span className={styles.metaLabel}>Authors:</span>{doiData.authors}</div>}
//      </div>

//      {/* Abstract Section */}
//      {doiData.abstract && (
//       <div>
//        <div className={styles.sectionLabel}>Abstract</div>
//        <TruncatedText 
//         text={doiData.abstract} 
//         initialLength={400} 
//         chunkSize={400} 
//        />
//       </div>
//      )}

//      {/* Full Text Snippet */}
//      {doiData.fullTextSnippet && (
//       <div>
//        <div className={styles.sectionLabel}>Full Text {doiData.abstract && '(Preview)'}</div>
//        <TruncatedText 
//         text={doiData.fullTextSnippet} 
//         initialLength={500} 
//         chunkSize={600} 
//        />
//        {!doiData.abstract && <div className={styles.footerNote}>(Text truncated for display purposes)</div>}
//       </div>
//      )}
//     </div>
//    ))}

//    {/* Feedback Actions embedded within styled bottom container */}
//    {children && (
//     <div className={styles.cardFooter}>
//      {children}
//     </div>
//    )}
//   </div>
//  );
// };

// RomineDoiBubble.propTypes = {
//  doiList: PropTypes.array.isRequired,
//  totalCount: PropTypes.number,
//  children: PropTypes.node
// };

// export default RomineDoiBubble;



import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { 
 Button, 
 Text, 
 makeStyles, 
 shorthands,
 Badge,
 Tooltip,
 mergeClasses
} from '@fluentui/react-components';
import { 
 ClipboardTask20Regular, 
 DocumentAdd20Regular,
 ChevronDown20Regular,
 ChevronUp20Regular,
 ChevronLeft16Regular,
 ChevronRight16Regular,
 ThumbLike20Regular,
 ThumbLike20Filled,
 ThumbDislike20Regular,
 ThumbDislike20Filled,
 ArrowDownload20Regular 
} from '@fluentui/react-icons';
import { toast } from 'react-hot-toast';
import { replaceSelectedContent } from "../utils/officeUtils";

const useStyles = makeStyles({
 container: {
  display: 'flex',
  flexDirection: 'column',
  padding: '8px 4px',
  backgroundColor: 'transparent',
  width: '100%',
 },
 card: {
  backgroundColor: '#ffffff',
  ...shorthands.border('1px', 'solid', '#f2d4ff'), 
  ...shorthands.borderRadius('8px'),
  boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
 },
 paginationBar: {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '6px 12px',
  // backgroundColor: '#f5f4f3', 
  backgroundColor: '#f2d4ff', //light purple
  // borderBottom: '1px solid #706b69',
    borderBottom: '1px solid #bc36f0', // little dark purple
 },
 resultsCount: {
  fontSize: '11px',
  fontWeight: '700',
  color: '#000',
 },
 cardHeader: {
  padding: '16px 16px 8px 16px',
  backgroundColor: '#ffffff',
 },
 foundCount: {
  fontSize: '12px',
  fontWeight: '700',
  color: '#333333',
  display: 'block',
  marginBottom: '12px',
 },
 titleLink: {
  fontSize: '13.5px',
  fontWeight: '600',
  color: '#0066cc', 
  textDecorationLine: 'none',
  display: 'inline-block',
  marginBottom: '10px',
  lineHeight: '1.4',
  ':hover': {
   textDecorationLine: 'underline',
   color: '#004b93',
  }
 },
 metaList: {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
 },
 metaItem: {
  fontSize: '11px',
  lineHeight: '1.5',
  color: '#333333',
 },
 accentLabel: {
  color: '#706b69', 
  fontWeight: '700',
  marginRight: '6px',
 },
 fullTextLabel: {
  color: '#706b69', 
  fontWeight: '700',
  fontSize: '12.5px',
  display: 'block',
  marginTop: '14px',
  marginBottom: '4px',
 },
 contentBody: {
  padding: '0 16px 14px 16px',
  fontSize: '12.5px',
  color: '#333333',
  lineHeight: '1.6',
  backgroundColor: '#ffffff',
  maxHeight: '300px',
  overflowY: 'auto',
 },
 sectionBlock: {
  marginBottom: '10px',
 },
 sectionTitle: {
  fontWeight: '700',
  color: '#706b69',
  fontSize: '11px',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  display: 'block',
  marginTop: '8px',
  marginBottom: '4px',
 },
 paragraph: {
  margin: '0 0 8px 0',
 },
 cardFooter: {
  padding: '8px 16px',
  backgroundColor: '#fafafa',
  borderTop: '1px solid #f0f0f0',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '8px',
 },
 footerActions: {
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
 },
 actionBtn: {
  fontSize: '11px',
  minWidth: 'auto',
  padding: '4px 10px',
 },
 thumbBtn: {
  minWidth: '32px',
  padding: '4px',
  ':hover': {
   backgroundColor: '#edebe9',
  }
 },
 toggleBtn: {
  color: '#605e5c',
  fontSize: '11px',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  cursor: 'pointer',
  userSelect: 'none',
  ':hover': {
   color: '#706b69',
  }
 }
});

const parseSectionContent = (text, classes) => {
 if (!text) return null;
 const chunks = text.split('\n');

 return chunks.map((chunk, index) => {
  const trimmed = chunk.trim();
  if (!trimmed) return null;

  if (trimmed.includes('::')) {
   const parts = trimmed.split('::');
   const title = parts[0].trim();
   const body = parts.slice(1).join('::').trim();

   return (
    <div key={index} className={classes.sectionBlock}>
     <span className={classes.sectionTitle}>{}</span>
     {body && <p className={classes.paragraph}>{body}</p>}
    </div>
   );
  }
  return <p key={index} className={classes.paragraph}>{trimmed}</p>;
 });
};

const RomineDoiBubble = ({ doiList, totalCount, requestLogId, onLogCopy, onFeedbackSubmit }) => {
 const styles = useStyles();
 const [currentIndex, setCurrentIndex] = useState(0);
 const [isExpanded, setIsExpanded] = useState(false);
 const [feedbackRating, setFeedbackRating] = useState(null);

 // if (!doiList || doiList.length === 0) {
 //  return (
 //   <div className={styles.container}>
 //    <div className={styles.card}>
 //     <div className={styles.foundHeader}>Found: 0 article(s)</div>
 //     <div style={{ padding: '16px', textAlign: 'center', color: '#605e5c', fontSize: '11.5px' }}>
 //      No search results matched your query criteria.
 //     </div>
 //    </div>
 //   </div>
 //  );
 // }

    if (!doiList || doiList.length === 0) {
  return (
   <div className={styles.container}>
    <div className={styles.card}>
     {/* Header pagination bar styled cleanly in matching light purple */}
     <div className={styles.paginationBar}>
      <Text className={styles.resultsCount}>
       Found : 0 article(s)
      </Text>
     </div>
     {/* Styled body copy wrapper */}
     <div style={{ padding: '24px 16px', textAlign: 'center', color: '#706b69', fontSize: '11.5px', lineHeight: '1.5' }}>
      No articles, data, or abstracts were found for your specified DOIs. Please verify your list and try again.
     </div>
    </div>
   </div>
  );
 }

 const item = doiList[currentIndex];
 
 // Unify snippet lookup text dynamically (Abstract fallback support)
 const itemText = item.fullTextSnippet || item.content || item.abstract || "";
 const truncatedSnippet = itemText && itemText.length > 220 
  ? itemText.substring(0, 220) + '...' 
  : itemText;

 // const handleCopyCitation = () => {
 //  const citation = `"${item.title}." ${item.authors || item.author || ''}. ${item.journal} ${item.publicationDate || item.year || ''};${item.publicationDetails || ''}. doi:${item.doi}`;
 //  navigator.clipboard.writeText(citation);
 //  toast.success("Citation copied to clipboard!");
 //  if (onLogCopy) onLogCopy(item.id || item.doi);
 // };

     const handleCopyCitation = () => {
      // Build the clean citation line
      const citation = `"${item.title || 'Untitled Article'}." ${item.authors || item.author || ''}. ${item.journal || ''} ${item.publicationDate || item.year || ''};${item.publicationDetails || ''}.${item.doi ? ' doi:' + item.doi : ''}`;
      
      // Retrieve the complete body text/snippet
      const articleContent = itemText || "";
      
      // Combine both
      const fullTextToCopy = `${citation}\n\n${articleContent}`;
      
      // Copy the complete package using the fallback hook
      copy(fullTextToCopy); 
      
      if (onLogCopy) onLogCopy(item.id || item.doi);
     };

 const handleInsertToWord = async () => {
  const insertionText = `${item.title} (${item.authors || item.author || ''}, ${item.publicationDate || item.year || ''}. ${item.journal}).`;
  try {
   if (window.Word) {
    await replaceSelectedContent(insertionText);
    toast.success("Reference inserted into document!");
    if (onLogCopy) onLogCopy(item.id || item.doi);
   } else {
    toast.error("Word Context missing. Copying citation instead.");
    navigator.clipboard.writeText(insertionText);
   }
  } catch (err) {
   console.error("Word insertion failed:", err);
   toast.error("Could not write to document.");
  }
 };

 const handleDownloadJson = () => {
  try {
   const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(item, null, 2));
   const downloadAnchor = document.createElement('a');
   downloadAnchor.setAttribute("href", dataStr);
   
   const safeTitle = (item.title || 'article').toLowerCase().replace(/[^a-z0-9]/g, '_').substring(0, 50);
   downloadAnchor.setAttribute("download", `article_metadata_${safeTitle}.json`);
   document.body.appendChild(downloadAnchor);
   downloadAnchor.click();
   downloadAnchor.remove();
   toast.success("JSON file downloaded!");
  } catch (err) {
   console.error("JSON extraction failed:", err);
   toast.error("Failed to generate metadata download.");
  }
 };

 const handleLikeClick = () => {
  const nextRating = feedbackRating === 1 ? null : 1;
  setFeedbackRating(nextRating);
  if (onFeedbackSubmit) {
   onFeedbackSubmit({
    request_log_id: requestLogId,
    rating: nextRating === 1 ? 1 : 0
   });
  }
 };

 const handleDislikeClick = () => {
  const nextRating = feedbackRating === -1 ? null : -1;
  setFeedbackRating(nextRating);
  if (onFeedbackSubmit) {
   onFeedbackSubmit({
    request_log_id: requestLogId,
    rating: nextRating === -1 ? -1 : 0
   });
  }
 };

 return (
  <div className={styles.container}>
   <div className={styles.card}>
     
    {/* Carousel Navigation Controller */}
    <div className={styles.paginationBar}>
     <Button 
      appearance="subtle" 
      icon={<ChevronLeft16Regular />} 
      disabled={currentIndex === 0} 
      size="small"
      onClick={() => {
       setCurrentIndex(prev => prev - 1);
       setIsExpanded(false);
      }}
     >
      Prev
     </Button>
      
     <Text className={styles.resultsCount}>
      Document {currentIndex + 1} of {doiList.length}
     </Text>

     <Button 
      appearance="subtle" 
      icon={<ChevronRight16Regular />} 
      iconPosition="after"
      disabled={currentIndex === doiList.length - 1} 
      size="small"
      onClick={() => {
       setCurrentIndex(prev => prev + 1);
       setIsExpanded(false);
      }}
     >
      Next
     </Button>
    </div>

    {/* Card Content Area */}
    <div className={styles.cardHeader}>
     <span className={styles.foundCount}>
      Found : {totalCount || doiList.length} article(s)
     </span>

     <a 
      href={item.url || (item.doi ? `https://doi.org/${item.doi}` : '#')} 
      target="_blank" 
      rel="noopener noreferrer" 
      className={styles.titleLink}
     >
      {currentIndex + 1}. {item.title}
     </a>

     <div className={styles.metaList}>
      {item.doi && (
       <div className={styles.metaItem}>
        <span className={styles.accentLabel}>DOI:</span>
        <span>{item.doi}</span>
       </div>
      )}
      {/* <div className={styles.metaItem}>
       <span className={styles.accentLabel}>Journal:</span>
       <span>{item.journal}</span>
      </div>
      {item.publicationDetails && (
       <div className={styles.metaItem}>
        <span className={styles.accentLabel}>Publication Details:</span>
        <span>{item.publicationDetails}</span>
       </div>
      )}
      <div className={styles.metaItem}>
       <span className={styles.accentLabel}>Publication Date:</span>
       <span>{item.publicationDate || 'N/A'}</span>
      </div> */}
      {/* <div className={styles.metaItem}>
       <span className={styles.accentLabel}>Authors:</span>
       <span>{item.authors || item.author || 'Unknown Authors'}</span>
      </div>
      
      {item.issn && (
       <div className={styles.metaItem}>
        <span className={styles.accentLabel}>ISSN:</span>
        <span>{item.issn}</span>
       </div>
      )}

      {item.data_provider && (
       <div className={styles.metaItem}>
        <span className={styles.accentLabel}>Data Provider:</span>
        <span>{item.data_provider}</span>
       </div>
      )} */}
     </div>

     <span className={styles.fullTextLabel}>Full Text</span>
    </div>

    {/* Snippet body rendering area */}
    <div className={styles.contentBody}>
     {isExpanded ? (
      parseSectionContent(itemText, styles)
     ) : (
      <p className={styles.paragraph}>
       {truncatedSnippet}
       {!isExpanded && itemText && itemText.length > 220 && (
        <span style={{ color: '#706b69', fontWeight: 'bold', cursor: 'pointer', marginLeft: '4px' }} onClick={() => setIsExpanded(true)}>
         read more
        </span>
       )}
      </p>
     )}
    </div>

    {/* Operation action footers */}
    <div className={styles.cardFooter}>
     <div className={styles.toggleBtn} onClick={() => setIsExpanded(!isExpanded)}>
      {isExpanded ? (
       <>
        <Text size={100}>Collapse view</Text>
        <ChevronUp20Regular style={{ fontSize: '12px' }} />
       </>
      ) : (
       <>
        <Text size={100}>Expand full text</Text>
        <ChevronDown20Regular style={{ fontSize: '12px' }} />
       </>
      )}
     </div>

     <div className={styles.footerActions}>
      {/* Thumbs Up / Like Button */}
      <Tooltip content="Like this article" relationship="label">
       <Button 
        appearance="subtle" 
        icon={feedbackRating === 1 ? <ThumbLike20Filled style={{ color: '#706b69' }} /> : <ThumbLike20Regular />} 
        className={mergeClasses(styles.actionBtn, styles.thumbBtn)}
        onClick={handleLikeClick}
       />
      </Tooltip>

      {/* Thumbs Down / Dislike Button */}
      <Tooltip content="Dislike this article" relationship="label">
       <Button 
        appearance="subtle" 
        icon={feedbackRating === -1 ? <ThumbDislike20Filled style={{ color: '#d13438' }} /> : <ThumbDislike20Regular />} 
        className={mergeClasses(styles.actionBtn, styles.thumbBtn)}
        onClick={handleDislikeClick}
       />
      </Tooltip>

      {/* JSON Download Button */}
      <Tooltip content="JSON Download" relationship="label">
       <Button 
        appearance="subtle" 
        icon={<ArrowDownload20Regular />} 
        className={mergeClasses(styles.actionBtn, styles.thumbBtn)}
        onClick={handleDownloadJson}
       />
      </Tooltip>

      {/* Copy Button */}
      <Tooltip content="Copy citation template to clipboard" relationship="label">
       <Button 
        appearance="subtle" 
        icon={<ClipboardTask20Regular />} 
        className={styles.actionBtn}
        onClick={handleCopyCitation}
       >
        Copy
       </Button>
      </Tooltip>

      {/* Insert Ref Button */}
      <Tooltip content="Insert reference at your document cursor" relationship="label">
       <Button 
        appearance="subtle" 
        icon={<DocumentAdd20Regular />} 
        className={mergeClasses(styles.actionBtn, styles.thumbBtn)}
        onClick={handleInsertToWord}
       />
      </Tooltip>
     </div>
    </div>

   </div>
  </div>
 );
};

RomineDoiBubble.propTypes = {
 doiList: PropTypes.arrayOf(
  PropTypes.shape({
   id: PropTypes.string,
   title: PropTypes.string,
   doi: PropTypes.string,
   journal: PropTypes.string,
   publicationDetails: PropTypes.string,
   publicationDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   authors: PropTypes.string,
   abstract: PropTypes.string,
   fullTextSnippet: PropTypes.string,
   content: PropTypes.string,
   issn: PropTypes.string,
   data_provider: PropTypes.string,
   url: PropTypes.string,
  })
 ).isRequired,
 totalCount: PropTypes.number,
 requestLogId: PropTypes.string,
 onLogCopy: PropTypes.func,
 onFeedbackSubmit: PropTypes.func
};

export default RomineDoiBubble;